import $ from 'jquery';

$('.image-info__icon').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).siblings('.image-info__text').toggleClass('image-info__text--show');
})
